import { Events, emit, on } from '../core/events.js';

const pauses = new Map();
const key = (scope, id) => `${scope}:${id}`;

export function getSyncPauses() { return [...pauses.values()].map(pause => ({ ...pause })); }
export function getSyncPause(scope, id) { return pauses.get(key(scope, id)) || null; }

export function reportSyncPause(scope, id, reason = 'unreadable') {
  if (!id) return;
  const previous = getSyncPause(scope, id);
  // Keep the more specific key-verification reason when decryption also fails.
  if (previous && reason === 'unreadable' && previous.reason !== 'unreadable') return;
  if (previous?.reason === reason && !previous.keyVerified) return;
  const pause = { scope, id, reason, keyVerified: false };
  pauses.set(key(scope, id), pause);
  emit(Events.SYNC_PAUSED, pause);
}

export function markSyncKeyVerified(id) {
  const pause = getSyncPause('map', id);
  if (pause) pause.keyVerified = true;
}

export function canResumeSync(scope, id) {
  const pause = getSyncPause(scope, id);
  return !pause || pause.reason === 'unreadable' || (scope === 'vault' && ['structure', 'protocol'].includes(pause.reason)) || pause.keyVerified;
}

/** Only a complete handshake clears the notice; clicking Retry does not. */
export function clearSyncPause(scope, id) {
  if (!canResumeSync(scope, id)) return;
  if (pauses.delete(key(scope, id))) emit(Events.SYNC_PAUSE_CHANGED);
}

on(Events.AUTH_LOGOUT, () => {
  pauses.clear();
  emit(Events.SYNC_PAUSE_CHANGED);
});
